import Button from "../../../components/shared/Button";
import BG from "@/assets/optimized-images/maqraah.jpg";
import pics from "@/assets/icons/maqrah.png";

const CustomerSurvey = () => {
  return (
    <div
      className="relative bg-cover  bg-no-repeat"
      style={{ backgroundImage: `url(${BG})` }}
    >
      <div className="absolute inset-0 bg-[#000000] opacity-90 "></div>
      <div className="relative z-10">
        <div className="transform mt-20 mb-10 w-full min-h-[70vh] sm:min-h-[57vh] rounded-[1.2rem] flex flex-col justify-between items-center text-center  p-2 sm:px-30 gap-y-5  relative">
          <div className="w-10 rounded-full">
            <img src={pics} alt="" />
          </div>
          <div className="space-y-3 sm:w-[80%] text-white">
            <h2 className="text-[1.5rem] font-semibold font-[Roboto] ">
              Your Feedback Matters!
            </h2>
            <p className=" font-[Roboto] text-sm sm:text-lg">
              Help Us Improve Maqrahaatu Tanzeel! We are committed to providing
              the best Quranic education and ensuring a seamless learning
              experience for our students worldwide. Your feedback is invaluable
              in helping us refine our services and enhance your journey with
              us. <br /> <br /> Be a part of our growth! Kindly share your
              thoughts and suggestions through our survey—we appreciate your
              time and input.
            </p>
          </div>
          <Button
            btnText={"Take Survey"}
            btnColor={"text-white hover:text-black"}
            padding={"!p-3 px-5"}
            btnBgColor={"bg-[#66B2FF] hover:bg-[white] "}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomerSurvey;
